export const handleObject = {

    changeValue(obj) {
        if (process.env.VUE_APP_SECURE_SCHEMA_REQUEST === 'true'){
            if (typeof obj === 'object') {
                // iterating over the object using for..in
                for (let keys in obj) {
                    //checking if the current value is an object itself
                    if (typeof obj[keys] === 'object') {
                        // if so then again calling the same function
                        this.changeValue(obj[keys])
                    } else if (typeof obj[keys] === 'string') {
                        // else getting the value and replacing single { with {{ and so on
                        let keyValue = obj[keys].replace('http://', 'https://');
                        obj[keys] = keyValue;
                    }
                }
            } else if (typeof obj === 'string') {
                return obj.replace('http://', 'https://');
            }
        }
        
        return obj;
    },
    changeUrlValue(obj,find,replace) {
        if (typeof obj === 'object') {
            // iterating over the object using for..in
            for (let keys in obj) {
                //checking if the current value is an object itself
                if (typeof obj[keys] === 'object') {
                    // if so then again calling the same function
                    this.changeUrlValue(obj[keys],find,replace)
                } else if (typeof obj[keys] === 'string') {
                    if (!(obj[keys]).includes('cciudadano')) {
                        let newObj = obj[keys].replace(find, replace)
                        obj[keys] = newObj
                    }
                }
            }
        } else if (typeof obj === 'string') {
            if (!obj.includes('cciudadano')) {
                let newObj = obj.replace(find, replace)
                obj = newObj
            }
        }
        return obj;
    },
    replaceValues(x, fx) {
        if (typeof x === 'object') {
            if (x.hasOwnProperty('variable')) {
                let data = fx
                    .filter(fxx => fxx.variable == x.variable)
                    .map(fy => (fy.data))
                    .map(fyy => (fyy[0]));
                if (data && data[0]) {
                    if (x.type == 'list'){
                        x.idk=x.id+Math.floor(Math.random() * 10) + 1;
                        x.value = data[0].json != null && data[0].json.length>0 ? data[0].json:data[0];
                    } 
                    else{
                        x.idk=x.id+(Math.floor(Math.random() * 10) + 1);
                        x.value = data[0].value;
                    }
                }
            } else {
                for (let keys in x) {
                    this.replaceValues(x[keys], fx);
                }
            }
        }
    }


}

export default handleObject